<!--DASHBOARD SETTINGS DIALOG-->
<div style="display: flex">
    <p-dialog header="Dashboard Settings" [(visible)]="showDashboardSettings"
        [maximizable]="true" [closable]="true" [closeOnEscape]="false" [style]="{ width: '60vw' }">
        <table style="width: 100%;">
            <thead>
                <tr class="table-header-row">
                    <td class="table-header-cell">
                        Dashboard Item
                    </td>
                    <td class="table-header-cell">
                        Description
                    </td>
                    <td class="table-header-cell">
                        Display
                    </td>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let row of dashboardSettingsTableData; let i=index">
                    <td class="table-cell">
                        {{ row.DashboardItem }}
                    </td>
                    <td class="table-cell">
                        {{ row.DashboardItemDesc }}
                    </td>
                    <td class="table-cell" style="text-align: center">
                        <p-checkbox
                            class="ef-checkbox"
                            binary="true"
                            (onChange)="updateSettingCheckboxChecked($event, row)"
                            [(ngModel)]="row.IsVisible"
                        ></p-checkbox>
                    </td>
                </tr>
            </tbody>
        </table>
    </p-dialog>
</div>

<div style="display: flex">
    <p-dialog header="How to submit a helpdesk ticket" [(visible)]="showVideo"
        [closable]="true" [closeOnEscape]="false" [style]="{width: '75vw', height: '90vh', backgroundColor: 'grey'}">
        <div style="justify-content: center; ">
            <video width="1280" height="768" controls>
                <source src="../../../videos/helpdesk.mp4" type="video/mp4">
                <source src="../../../videos/helpdesk.webm" type="video/webm">
                <source src="../../../videos/helpdesk.ogg" type="video/ogg">
            </video>
        </div>
    </p-dialog>
</div>

<p-toolbar class="dashboard-header">
    <div class="flex flex-direction-row w-full">
        <div class="w-3 ml-2 px-3 mt-0 vertical-align-center">
            <div *ngIf="this.user" style="line-height: 2.5rem;" class="text-900 font-medium mb-0 text-xl text-white">{{ this.user.userInfo.EmployeeName }} Dashboard</div>
        </div>

        <div class="flex justify-content-end w-9 px-3 mt-0">
            <div class="message-button-container">
                <span
                    class="message-badge"
                    *ngIf="messageStateService.showBadge"
                >{{ messageStateService.messageCount }}</span>
                <button
                    pButton
                    type="button"
                    class="p-button-text message-button"
                    (click)="openMessages()"
                    title="Messages"
                >
                    <i class="pi pi-fw pi-envelope" style="font-size: 1.5rem; font-weight: bold;"></i>
                </button>
            </div>
            <div>
                <button pButton pRipple class="text-base p-button-text" (click)="openDashboardSettings()" title="Dashboard settings">
                    <i class="pi pi-fw pi-cog" style="font-size: 1.5rem; font-weight: bold;"></i>
                </button>
            </div>
        </div>
    </div>
</p-toolbar>
<div class="w-full pt-1" *ngIf="roleID == 1">
    <ef-bizprocess-menu [isMainPage]="false"></ef-bizprocess-menu>
</div>

<!-- <div class="col md:col-12 lg:col-12 xl:col-12">
    <div class="grid px-0 m-0">
        <div class="col-4">
            <div *ngIf="this.user" class="text-900 font-medium mb-3 text-xl">{{ this.user.userInfo.EmployeeName }}'s Dashboard</div>
        </div>
        <div class="col-8 p-0">
            <div class="flex align-items-end justify-content-end">
                <span class="w-full flex " style="position:relative;justify-content:flex-end;">
                    <span
                        style="position:absolute;top:0;right:0;margin-top: -.1em;margin-right: .75em;background-color: red;"
                        class="badge text-xs border-round text-white"
                        *ngIf="this.messageCount != 0 && this.showMsg"
                    >{{ this.messageCount }}</span>
                    <button
                        pButton
                        type="button"
                        class="p-button-text"
                        (click)="openMessages()"
                        title="Messages"
                    >
                        <i class="pi pi-envelope" style="font-size: 1.5rem"></i>
                    </button>
                </span>
                <button pButton pRipple class="text-base p-button-text" (click)="openDashboardSettings()" title="Dashboard settings">
                    <i class="pi pi-cog" style="font-size: 1.5rem"></i>
                </button>
            </div>
        </div>
    </div>
</div> -->


<!--ANNOUNCEMENT-->
<div class="grid flex justify-content-center mt-5">
    <div *ngIf="announcement" [ngClass]="announcementAdmin != null && this.roleID == 1 ? 'xl:col-6' : 'xl:col-12'" class="col mb-1 col-auto lg:col-12 md:col-12 sm:col-12 xs:col-12 border-round" style="background-color: #cce5ff;">
        <div class="surface-card border-round text-center shadow-2 p-4" style="height: 100%; background-color: #cce5ff;">
            <div class="border-round">
                <div class="p-2 flex justify-content-center text-center">
                    <div *ngIf="!!announcement" class="mt-0 p-0 line-height-3 col col-12 text-sm" [innerHTML]="announcement | safe: 'html'"></div>
                </div>
            </div>
        </div>
    </div>
    <div *ngIf="announcementAdmin != null && this.roleID == 1" [ngClass]="announcement != null ? 'xl:col-6' : 'xl:col-12'" class="col mb-1 col-auto lg:col-12 md:col-12 sm:col-12 xs:col-12 border-round" style="background-color: #cce5ff;">
        <div class="surface-card border-round text-center shadow-2 p-4" style="height: 100%; background-color: #cce5ff;">
            <div class="border-round">
                <div class="p-2 flex justify-content-center text-center">
                    <div *ngIf="!!announcementAdmin" class="mt-0 p-0 line-height-3 col col-12 text-sm" [innerHTML]="announcementAdmin | safe: 'html'"></div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="p-5 pt-0 flex flex-column flex-auto">
    <div class="grid">

        <!--PROGRESS TRACKER-->
        <!-- <div class="col lg:col-auto" hidden="true">
            <div class="surface-card shadow-2 border-round p-4 text-center" style="height: 100%">
                <div class="flex align-items-center justify-content-between mb-4">
                    <span class="text-xl font-medium text-900">Quarter Goals</span>
                </div>
                <div class="surface-border border-1 border-round p-3 mb-4">
                    <span class="text-900 font-medium text-3xl">85% <span class="text-600">(2125/2500)</span></span>
                    <ul class="mt-3 list-none p-0 mx-0 flex">
                        <li style="height:1rem" class="flex-1 bg-indigo-500 border-round-left"></li>
                        <li style="height:1rem" class="flex-1 bg-blue-500"></li>
                        <li style="height:1rem" class="flex-1 bg-orange-500"></li>
                    </ul>
                </div>
                <ul class="mt-4 list-none p-0 mx-0">
                    <li class="flex align-items-center pb-3">
                        <span style="width:1rem;height:1rem" class="border-round bg-indigo-500 mr-3 flex-shrink-0"></span>
                        <span class="text-xl font-medium text-90">Customers</span>
                        <span class="text-600 text-xl font-medium ml-auto">25100</span>
                    </li>
                    <li class="flex align-items-center py-3">
                        <span style="width:1rem;height:1rem" class="border-round bg-blue-500 mr-3 flex-shrink-0"></span>
                        <span class="text-xl font-medium text-90">Orders</span>
                        <span class="text-600 text-xl font-medium ml-auto">152</span>
                    </li>
                    <li class="flex align-items-center py-3">
                        <span style="width:1rem;height:1rem" class="border-round bg-orange-500 mr-3 flex-shrink-0"></span>
                        <span class="text-xl font-medium text-90">Revenue</span>
                        <span class="text-600 text-xl font-medium ml-auto">1500</span>
                    </li>
                </ul>
            </div>
        </div> -->

        <!--MESSAGE CARD-->
        <div class="col col-12" *ngIf="this.showMessageBlock == true">
            <div class="surface-card border-round shadow-2 p-4 text-center" style="height: 100%">
                <div class="flex align-items-center justify-content-between mb-3">
                    <div class="text-900 font-medium mb-3 text-xl">Messages</div>
                    <button pButton pRipple icon="pi pi-times" class="p-button-danger p-button-rounded p-button-text" (click)="this.showMessageBlock = false"></button>
                </div>

                <div class="grid flex align-items-center justify-content-center">
                    <div *ngIf="this.roleID == 1 && !!adminMsg" class="mt-0 mb-4 p-0 line-height-3 col col-4 text-sm" [innerHTML]="adminMsg | safe: 'html'"></div>
                    <div *ngIf="this.roleID == 12024 || this.roleID == 12025 || this.roleID == 1 && !!mgrMsg" class="mt-0 mb-4 p-0 line-height-3 col col-4 text-sm" [innerHTML]="mgrMsg | safe: 'html'"></div>
                    <div *ngIf="!!userMsg" class="mt-0 mb-4 p-0 line-height-3 col col-4 text-sm" [innerHTML]="userMsg | safe: 'html'"></div>
                </div>

                <div class="flex items-center align-items-end justify-content-end mb-1">
                    <p-checkbox
                        [ngModel]="messageStateService.markAsRead"
                        [binary]="true"
                        (onChange)="onMarkAsReadChanged($event)"
                    ></p-checkbox>
                    <span class="ml-2 text-sm text-600">Mark as read</span>
                </div>
            </div>
        </div>
        <!--QUICK ACCESS-->
        <div *ngIf='quickAccessIsVisible == true' class="col col-auto flex-grow-1 xl:col-2 lg:col-3 md:col-3 sm:col-3 xs:col-12">
            <div class="surface-card border-round shadow-2 p-4 text-center" style="height: 100%">
                <span class="text-xl font-medium text-90">Quick Access</span>
                <ul *ngIf="selectedProcesses" class="mt-2 list-none p-0 mx-0">
                    <li class="py-1 mx-0 w-full" *ngFor="let process of selectedProcesses">
                        <!-- <div class="w-full flex flex-direction-row">
                            <button
                                pButton
                                type="button"
                                class="w-full quick-access p-button-raised bg-transparent text-primary hover:bg-primary text-sm"
                                (click)="app.onProcessClick(process)"
                                [label]="process.ProcessTitle"
                            ></button>
                            <span
                                style="margin-bottom: 1.3em"
                                *ngIf="process.MsgCount"
                                class="topbar-badge animated rubberBand"
                            >{{ process.MsgCount }}</span>
                        </div> -->
                        <span class="w-full flex align-self-top" style="position:relative;">
                            <span *ngIf="process && process.MsgCount != null" style="position:absolute;top:0;right:0;margin-top: -.5em;margin-right: -.75em;" class="badge text-xs border-round bg-yellow-500 text-primary">{{ process.MsgCount }}</span>
                            <button
                                pButton
                                type="button"
                                class="w-full p-button-raised bg-transparent hover:bg-primary text-primary text-sm"
                                (click)="app.onProcessClick(process)"
                                [title]="process && process.ProcessTitle != null ? process.ProcessTitle : ''"
                                [label]="process && process.ProcessTitle != null ? process.ProcessTitle : ''"
                            ></button>
                        </span>

                    </li>
                </ul>
            </div>
        </div>

        <!--STAT DISPLAY-->
        <!-- <div class="col-12">
            <div class="surface-card shadow-2 border-round flex p-3 flex-row md:flex-row">
                <div class="border-bottom-1 md:border-right-1 md:border-bottom-none surface-border flex-auto p-3">
                    <div class="flex align-items-center mb-3">
                        <i class="pi pi-shopping-cart text-blue-500 text-xl mr-2"></i>
                        <span class="text-500 font-medium">Orders</span>
                    </div>
                    <span class="block text-900 font-medium mb-4 text-xl">152 New</span>
                    <div class="flex align-items-center">
                        <i class="pi pi-arrow-down text-pink-500 text-xl mr-2"></i>
                        <span class="text-pink-500 font-medium ">-25</span>
                    </div>
                </div>
                <div class="border-bottom-1 md:border-right-1 md:border-bottom-none surface-border flex-auto p-3">
                    <div class="flex align-items-center mb-3">
                        <i class="pi pi-shopping-cart text-orange-500 text-xl mr-2"></i>
                        <span class="text-500 font-medium">Revenue</span>
                    </div>
                    <span class="block text-900 font-medium mb-4 text-xl">$1500</span>
                    <div class="flex align-items-center">
                        <i class="pi pi-arrow-up text-green-500 text-xl mr-2"></i>
                        <span class="text-green-500 font-medium ">+15</span>
                    </div>
                </div>
                <div class="border-bottom-1 md:border-right-1 md:border-bottom-none surface-border flex-auto p-3">
                    <div class="flex align-items-center mb-3">
                        <i class="pi pi-users text-cyan-500 text-xl mr-2"></i>
                        <span class="text-500 font-medium">Customers</span>
                    </div>
                    <span class="block text-900 font-medium mb-4 text-xl">25100</span>
                    <div class="flex align-items-center">
                        <i class="pi pi-arrow-up text-green-500 text-xl mr-2"></i>
                        <span class="text-green-500 font-medium ">+%12</span>
                    </div>
                </div>
                <div class="flex-auto p-3">
                    <div class="flex align-items-center mb-3">
                        <i class="pi pi-users text-purple-500 text-xl mr-2"></i>
                        <span class="text-500 font-medium">Profit</span>
                    </div>
                    <span class="block text-900 font-medium mb-4 text-xl">7200</span>
                    <div class="flex align-items-center">
                        <i class="pi pi-arrow-up text-green-500 text-xl mr-2"></i>
                        <span class="text-green-500 font-medium ">+2000</span>
                    </div>
                </div>
            </div>
        </div> -->
        <!-- col-12 xl:col-4 md:col-12 lg:col-12 p-2 -->
        <div *ngIf='myStatusIsVisible == true' class="col flex-grow-1 col-auto xl:col-2 lg:col-4 md:col-4 sm:col-12 xs:col-12 p-2">
            <div class="shadow-2 surface-card border-round p-4 h-full">
                <div class="flex align-items-start mb-5">
                    <div class="ml-3">
                        <span class="block text-900 mb-1 text-xl font-medium">My Status</span>
                        <p class="text-600 mt-0 mb-0">Notifications</p>
                    </div>
                </div>
                <ul class="list-none p-0 m-0">
                    <li class="mb-2" *ngFor="let data of statusData">
                        <div class="flex justify-content-between align-items-center" *ngIf="data.RoleID == 12028">
                            <span class="text-900 inline-flex justify-content-between align-items-center">
                                <a *ngIf="data.Process != null" class="font-medium text-900 text-sm" href='javascript:;' (click)="app.onProcessClick(data.Process)">{{ data.RoleAction }}</a>
                                <a *ngIf="data.Process == null" class="font-medium text-900 text-sm" href='javascript:;'>{{ data.RoleAction }}</a>
                            </span>
                            <div class="bg-gray-700 p-1 px-1 inline-flex border-round justify-content-center w-3">
                                <span class="text-white font-medium" style="font-size: .65rem;">{{ data.RoleActionCount }}</span>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
        <div class="col col-auto flex-grow-1 xl:col-4 lg:col-9 md:col-9 sm:col-9 xs:col-12 p-2" *ngIf="this.roleID == 1 && this.adminActionsIsVisible == true">
            <div class="shadow-2 surface-card border-round p-4 h-full">
                <div class="flex align-items-start mb-5">
                    <div class="ml-3">
                        <span class="block text-900 mb-1 text-xl font-medium">Administrator</span>
                        <p class="text-600 mt-0 mb-0">Overall Actions Pending</p>
                    </div>
                </div>
                <ul class="list-none p-0 m-0 grid">
                    <li class="col col-6 mb-1" *ngFor="let data of statusData">
                        <div class="flex justify-content-between align-items-center p-0 m-0" *ngIf="data.RoleID == 1">
                            <span class="text-900 inline-flex justify-content-between align-items-center">
                                <a *ngIf="data.ProcessID != null" class="font-medium text-900 text-sm" href='javascript:;' (click)="app.onProcessClick(data.Process)">{{ data.RoleAction }}</a>
                                <span *ngIf="data.ProcessID == null" class="font-medium text-900 text-sm">{{ data.RoleAction }}</span>
                            </span>
                            <div class="bg-gray-700 p-1 px-1 inline-flex border-round justify-content-center w-3">
                                <span *ngIf="data.RoleActionCount == 1" class="text-white font-medium" style="font-size: .65rem;">{{ data.RoleActionCount }} user</span>
                                <span *ngIf="data.RoleActionCount > 1" class="text-white font-medium" style="font-size: .65rem;">{{ data.RoleActionCount }} users</span>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
        <div class="col col-auto flex-grow-1 xl:col-2 lg:col-4 md:col-4 sm:col-6 xs:col-12 p-2" *ngIf="showSupervisorStatusBlock == true && this.supActionsIsVisible == true">
            <div class="shadow-2 surface-card border-round p-4 h-full">
                <div class="flex align-items-start mb-5">
                    <div class="ml-3">
                        <span class="block text-900 mb-1 text-xl font-medium">Supervisor</span>
                        <p class="text-600 mt-0 mb-0">My Actions Pending</p>
                    </div>
                </div>
                <ul class="list-none p-0 m-0">
                    <li class="mb-2" *ngFor="let data of statusData">
                        <div class="flex justify-content-between align-items-center" *ngIf="data.RoleID == 12024">
                            <span class="text-900 inline-flex justify-content-between align-items-center">
                                <a class="font-medium text-900 text-sm" href='javascript:;' (click)="app.onProcessClick(data.Process)">{{ data.RoleAction }}</a>
                            </span>
                            <div class="bg-gray-700 p-1 px-2 inline-flex border-round justify-content-center w-3">
                                <span *ngIf="data.RoleActionCount == 1" class="text-white font-medium" style="font-size: .65rem;">{{ data.RoleActionCount }} user</span>
                                <span *ngIf="data.RoleActionCount > 1" class="text-white font-medium" style="font-size: .65rem;">{{ data.RoleActionCount }} users</span>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
        <div class="col col-auto flex-grow-1 xl:col-2 lg:col-4 md:col-4 sm:col-6 xs:col-12 p-2" *ngIf="showPMStatusBlock == true && this.pmActionsIsVisible == true">
            <div class="shadow-2 surface-card border-round p-4 h-full">
                <div class="flex align-items-start mb-5">
                    <div class="ml-3">
                        <span class="block text-900 mb-1 text-xl font-medium">Project Manager</span>
                        <p class="text-600 mt-0 mb-0">My Actions Pending</p>
                    </div>
                </div>
                <ul class="list-none p-0 m-0">
                    <li class="mb-2" *ngFor="let data of statusData">
                        <div class="flex justify-content-between align-items-center" *ngIf="data.RoleID == 12025">
                            <span class="text-900 inline-flex justify-content-between align-items-center">
                                <a class="font-medium text-900 text-sm" href='javascript:;' (click)="app.onProcessClick(data.Process)">{{ data.RoleAction }}</a>
                            </span>
                            <div class="bg-gray-700 p-1 px-1 inline-flex border-round justify-content-center w-3">
                                <span *ngIf="data.RoleActionCount == 1" class="text-white font-medium" style="font-size: .65rem;">{{ data.RoleActionCount }} user</span>
                                <span *ngIf="data.RoleActionCount > 1" class="text-white font-medium" style="font-size: .65rem;">{{ data.RoleActionCount }} users</span>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>

        <!-- <div class="col col-auto xl:col-2 lg:col-4 md:col-4 sm:col-12 xs:col-12 p-2">
            <div class="shadow-2 surface-card border-round p-4 h-full">
                <div class="flex align-items-start mb-5">
                    <div class="ml-3">
                        <span class="block text-900 mb-1 text-xl font-medium">My Status</span>
                        <p class="text-600 mt-0 mb-0">Notifications</p>
                    </div>
                </div>
                <ul class="list-none p-0 m-0">
                    <li class="mb-2" *ngFor="let data of statusData">
                        <div class="flex justify-content-between align-items-center" *ngIf="data.RoleID == 12028">
                            <span class="text-900 inline-flex justify-content-between align-items-center">
                                <a *ngIf="data.Process != null" class="font-medium text-900 text-sm" href='javascript:;' (click)="app.onProcessClick(data.Process)">{{ data.RoleAction }}</a>
                                <a *ngIf="data.Process == null" class="font-medium text-900 text-sm" href='javascript:;'>{{ data.RoleAction }}</a>
                            </span>
                            <div class="bg-gray-700 p-1 px-1 inline-flex border-round justify-content-center w-3">
                                <span class="text-white font-medium" style="font-size: .65rem;">{{ data.RoleActionCount }}</span>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </div> -->

        <!--LINE CHART-->
        <!-- <div class="col-12 lg:col-6">
            <div class="surface-card shadow-2 border-round p-4">
                <div class="flex align-items-center justify-content-between mb-3">
                    <div class="text-900 font-medium text-xl">Sales</div>
                    <div>
                        <button pButton pRipple icon="pi pi-ellipsis-v" class="p-button-text p-button-plain p-button-rounded" (click)="menu3.toggle($event)"></button>
                        <p-menu #menu3 [popup]="true" [model]="items"></p-menu>
                    </div>
                </div>
                <p-chart type="line" [data]="lineStylesData" [options]="basicOptions"></p-chart>
            </div>
        </div> -->

        <!--CONTRACT BAR CHART-->
        <!-- *ngIf="contractsAndFundingProcess != null && this.hasActivity == true" -->
        <div class="col md:col-12 lg:col-12 xl:col-6" *ngIf="contractGraphIsVisible == true">
            <div class="surface-card shadow-2 border-round p-4" style="height: 100%;">
                <div>
                    <div class="ml-3">
                        <a href="javascript:;" (click)="app.onProcessClick(contractsAndFundingProcess)" class="text-900 font-medium text-xl">
                            Contract Funding & Status
                        </a>

                        <p class="text-600 mt-0 mb-0">Period processing through {{ maxProcessDate }}.  Latest funding mod {{ lastFundingMod }}</p>
                    </div>

                    <div class="flex align-items-center justify-content-center mb-3">
                        <form [formGroup]="contractFormGroup" #contractForm="ngForm" id="contractForm">
                            <div class="flex flex-direction-row border-round p-3">
                                <p-selectButton class="mt-1 pr-3" [options]="contractChartTypes" formControlName="percentSpent"></p-selectButton>
                                <div class="flex items-center mt-2 mr-3">
                                    <p-checkbox
                                        inputId="fundingdetail"
                                        formControlName="toggle"
                                        [binary]="true"
                                        title="View the funding detail of a contract by charge number."
                                    >
                                    </p-checkbox>
                                    <label for="fundingdetail" class="ml-1 text-600">Funding Detail</label>
                                </div>

                                <p-multiSelect
                                    *ngIf="this.contractFormGroup.controls['toggle'].value == false"
                                    defaultLabel="Contracts"
                                    maxSelectedLabels="1"
                                    appendTo="body"
                                    [options]="contractsSelectItem"
                                    [filter]="true"
                                    formControlName="MultiContract"
                                    maxSelectedLabels="1"
                                    selectedItemsLabel="{0} items selected"
                                    (onChange)="onChangeContracts($event)"
                                    [showToggleAll]="false"
                                >
                                </p-multiSelect>
                                <p-dropdown
                                    *ngIf="this.contractFormGroup.controls['toggle'].value == true"
                                    placeholder="Contracts"
                                    appendTo="body"
                                    autoDisplayFirst="false"
                                    [options]="contractsSelectItem"
                                    formControlName="Contract"
                                >
                                </p-dropdown>
                            </div>

                        </form>
                    </div>
                </div>
                <div class="legend flex justify-content-center">
                    <div class="flex flex-direction-row justify-content-center">
                        <div class="flex-direction-row justify-content-center">
                            <span style="background-color: #466060; padding-left: 3.5em; margin-right: .2em; margin-left: .5em; font-size: 12px;"></span>
                            <label pLabel type="text" style="font-size: 12px; color: #495057;">Awarded</label>
                        </div>
                        <div class="flex-direction-row justify-content-center">
                            <span style="background-color: #57886C; padding-left: 3.5em; margin-right: .2em; margin-left: .5em; font-size: 12px;"></span>
                            <label pLabel type="text" style="font-size: 12px; color: #495057;">Funded</label>
                        </div>
                        <div class="flex-direction-row justify-content-center">
                            <span style="background-color: #85BAA1; padding-left: 3.5em; margin-right: .2em; margin-left: .5em; font-size: 12px;"></span>
                            <label pLabel type="text" style="font-size: 12px; color: #495057;">Spent</label>
                        </div>
                        <div class="flex-direction-row justify-content-center">
                            <span style="background-color: #9A2A2A; padding-left: 3.5em; margin-right: .2em; margin-left: .5em; font-size: 12px;"></span>
                            <label pLabel type="text" style="font-size: 12px; color: #495057;">Over 100%</label>
                        </div>
                    </div>
                </div>
                <p-chart type="bar" [data]="fundingData" [options]="stackedOptions"></p-chart>
            </div>
        </div>

        <!--PLANNED HOURS BAR CHART-->
        <div class="col md:col-12 lg:col-12 xl:col-6" *ngIf="plannedHoursGraphIsVisible == true">
            <div class="surface-card shadow-2 border-round p-4">
                <div>
                    <div class="ml-3">
                        <a *ngIf="this.auths == null" href="https://www.efaactcentral.com/eFAACTUserManual/index.htm?context=320" target="_blank" class="text-900 font-medium text-xl">{{ supervisorGraphTitle }}</a>
                        <a *ngIf="this.auths != null" href="javascript:;" (click)="app.onProcessClick(this.auths)" class="text-900 font-medium text-xl">{{ supervisorGraphTitle }}</a>
                        <p class="text-600 mt-0 mb-0">Users with planned hours per task</p>
                    </div>

                    <div *ngIf="this.roleID == 1 || this.roleID == 12024" class="flex align-items-center justify-content-around mb-3">
                        <form [formGroup]="supGraphFormGroup" #contractForm="ngForm" id="supGraphForm">
                            <div class="flex flex-direction-row border-round p-3">
                                <p-selectButton class="mt-1 pr-3" [options]="chartTypes" formControlName="percent"></p-selectButton>
                                <div class="flex items-center mt-2 mr-3">
                                    <p-checkbox
                                        formControlName="tasktoggle"
                                        [binary]="true"
                                        title="View a user's planned hours by task."
                                    ></p-checkbox>
                                    <label for="fundingdetail" class="ml-1 text-600">Include Tasks</label>
                                </div>
                                <p-multiSelect
                                    *ngIf="this.supGraphFormGroup.controls['tasktoggle'].value == false"
                                    defaultLabel="Users"
                                    maxSelectedLabels="1"
                                    appendTo="body"
                                    [options]="usersSelectItem"
                                    [filter]="true"
                                    formControlName="users"
                                    maxSelectedLabels="1"
                                    selectedItemsLabel="{0} items selected"
                                    [showToggleAll]="false"
                                >
                                </p-multiSelect>
                                <p-dropdown
                                    *ngIf="this.supGraphFormGroup.controls['tasktoggle'].value == true"
                                    placeholder="Users"
                                    appendTo="body"
                                    autoDisplayFirst="false"
                                    [options]="usersSelectItem"
                                    formControlName="user"
                                >
                                </p-dropdown>
                                <div class="flex items-center mt-2 ml-3">
                                    <p-checkbox
                                        formControlName="drOnly"
                                        [binary]="true"
                                        title="Restrict the 'Users' dropdown to your direct reports."
                                    >
                                    </p-checkbox>
                                    <label for="fundingdetail" class="ml-1 text-600">My direct reports only</label>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
                <div class="legend flex justify-content-center">
                    <div class="flex flex-direction-row justify-content-center">
                        <div class="flex-direction-row justify-content-center">
                            <span style="background-color: #1e3c72; padding-left: 3.5em; margin-right: .2em; margin-left: .5em; font-size: 12px;"></span>
                            <label pLabel type="text" style="font-size: 12px; color: #495057;">Planned</label>
                        </div>
                        <div class="flex-direction-row justify-content-center">
                            <span style="background-color: #337ab7; padding-left: 3.5em; margin-right: .2em; margin-left: .5em; font-size: 12px;"></span>
                            <label pLabel type="text" style="font-size: 12px; color: #495057;">Worked</label>
                        </div>
                        <div class="flex-direction-row justify-content-center">
                            <span style="background-color: #9A2A2A; padding-left: 3.5em; margin-right: .2em; margin-left: .5em; font-size: 12px;"></span>
                            <label pLabel type="text" style="font-size: 12px; color: #495057;">Over 100%</label>
                        </div>
                    </div>
                </div>
                <p-chart type="bar" [data]="usersData" [options]="supStackedOptions"></p-chart>
            </div>
        </div>

        <!--ACCRUAL LINE CHART-->
        <div class="col md:col-12 lg:col-12 xl:col-6" *ngIf="showAccrualGraphs == true && leaveGraphIsVisible == true">
            <div class="surface-card shadow-2 border-round p-4" style="height: 100%">
                <div>
                    <div class="ml-3" [ngClass]="this.roleID == 12024 ? 'ef-mb-3' : 'mb-0'">
                        <a href="javascript:;" class="text-900 font-medium text-xl">
                            My Available Leave
                        </a>

                        <p class="text-600 mt-0 mb-0">Leave by pay period for the fiscal year</p>
                    </div>
                </div>
                <p-chart type="line" [data]="accrualChartData" [options]="accrualChartOptions"></p-chart>
            </div>
        </div>

    </div>

    <!-- <div class="button-bar">
        <div id='product-component-1667495584882'></div>
        <div id='product-component-1667502701454'></div>
    </div> -->

</div>

